import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string | undefined;

function createSupabaseClient(): SupabaseClient {
  if (!supabaseUrl || !supabaseAnonKey) {
    console.warn(
      "[Supabase] Kimlik bilgileri eksik. Netlify/Production ortamında VITE_PUBLIC_SUPABASE_URL ve VITE_PUBLIC_SUPABASE_ANON_KEY değişkenlerini tanımlayın."
    );
    return new Proxy({} as SupabaseClient, {
      get(_target, outerProp) {
        if (outerProp === "auth") {
          const authProxy = {
            getSession: () => Promise.resolve({ data: { session: null }, error: null }),
            onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
            signInWithPassword: () => Promise.resolve({ data: null, error: new Error("Supabase yapılandırılmadı") }),
            signUp: () => Promise.resolve({ data: null, error: new Error("Supabase yapılandırılmadı") }),
            signOut: () => Promise.resolve({ error: null }),
            resetPasswordForEmail: () => Promise.resolve({ data: {}, error: null }),
          };
          return authProxy;
        }
        if (outerProp === "from") {
          return () => ({
            select: () => ({
              eq: () => ({
                maybeSingle: () => Promise.resolve({ data: null, error: null }),
                single: () => Promise.resolve({ data: null, error: null }),
                order: () => Promise.resolve({ data: [], error: null }),
                limit: () => Promise.resolve({ data: [], error: null }),
                range: () => Promise.resolve({ data: [], error: null }),
                gte: () => ({ lte: () => Promise.resolve({ data: [], error: null }) }),
                gt: () => Promise.resolve({ data: [], error: null }),
                lt: () => Promise.resolve({ data: [], error: null }),
                neq: () => Promise.resolve({ data: [], error: null }),
              }),
              order: () => Promise.resolve({ data: [], error: null }),
              limit: () => Promise.resolve({ data: [], error: null }),
              range: () => Promise.resolve({ data: [], error: null }),
              gte: () => ({ lte: () => Promise.resolve({ data: [], error: null }) }),
              gt: () => Promise.resolve({ data: [], error: null }),
              lt: () => Promise.resolve({ data: [], error: null }),
              neq: () => Promise.resolve({ data: [], error: null }),
              single: () => Promise.resolve({ data: null, error: null }),
              maybeSingle: () => Promise.resolve({ data: null, error: null }),
            }),
            insert: () => ({ select: () => ({ single: () => Promise.resolve({ data: null, error: null }) }) }),
            update: () => ({ eq: () => Promise.resolve({ data: null, error: null }) }),
            delete: () => ({ eq: () => Promise.resolve({ data: null, error: null }) }),
            upsert: () => ({ select: () => ({ single: () => Promise.resolve({ data: null, error: null }) }) }),
          });
        }
        return undefined;
      },
    });
  }

  return createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  });
}

export const supabase = createSupabaseClient();